import { Map, OrderedMap, fromJS } from 'immutable';
import { isEmpty } from 'lodash';

import BaInfoConstants from 'Shared/constants/BaInfo.constants';

const initialState = Map({
  [BaInfoConstants.State.BA_INFO_BY_USER_SLUG]: OrderedMap(),
  [BaInfoConstants.State.PENDING_BA_ASSESSMENT_ID_BY_USER_SLUG]: OrderedMap(),
});

export const BaInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case BaInfoConstants.Actions.GET_BA_INFO_SUCCESS:
      if (isEmpty(action.payload)) {
        return state;
      }

      return state.setIn(
        [BaInfoConstants.State.BA_INFO_BY_USER_SLUG, action.payload.userGuid],
        Map(fromJS(action.payload))
      );

    case BaInfoConstants.Actions.CREATE_BA_SUCCESS:
      if (isEmpty(action.payload)) {
        return state;
      }

      return state.setIn(
        [BaInfoConstants.State.PENDING_BA_ASSESSMENT_ID_BY_USER_SLUG, action.payload.userGuid],
        action.payload.assessmentId
      );
    default:
      return state;
  }
};
